
import { useState, useEffect } from 'react';
import { User, UserRole } from '@/types/userRole';
import { getCurrentUser } from '@/utils/auth';

interface Session {
  user: User | null;
  isLoading: boolean;
  currentInstanceId: string | null;
  userRole: UserRole | null;
}

export const useSession = (): Session => {
  const [user, setUser] = useState<User | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [currentInstanceId, setCurrentInstanceId] = useState<string | null>(null);
  
  useEffect(() => {
    const loadUserSession = () => {
      try {
        const currentUser = getCurrentUser();
        setUser(currentUser);
        
        // In a real app, you would get this from a context or from the URL
        setCurrentInstanceId('instance-1');
      } catch (error) {
        console.error('Error loading user session:', error);
      } finally {
        setIsLoading(false);
      }
    };
    
    loadUserSession();
  }, []);
  
  return {
    user,
    isLoading,
    currentInstanceId,
    userRole: user?.role || null
  };
};
